export enum REFRESH_INVENTORY_ACT_TABLE {
  REFRESH = "REFRESH_INVENTORY_ACT_TABLE.REFRESH",
  CLEAR = "REFRESH_INVENTORY_ACT_TABLE.CLEAR",
}
